import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../app/hook";
import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";
import {
  logout,
  selectIsRememberMe,
  selectUserAuthStatus
} from "../../features/auth/auth.slice";
import useComponentVisible from "../../hooks/useComponentVisible";
import { useWindowSize } from "../../hooks/useWindowSize";
import { LogoIcon } from "../common/icons/logo.icon";

type Props = {
  theme?: string;
};

export default function SiteNavbarComponent({ theme }: Props) {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const location = useLocation();

  const isAuthentication = useAppSelector(selectUserAuthStatus);

  const isRememberMe = useAppSelector(selectIsRememberMe);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (!isRememberMe) {
      dispatch(logout());
    }
  }, [isRememberMe]);

  const [menuOpen, setMenuOpen] = useState(false);
  const { ref, isComponentVisible } = useComponentVisible(menuOpen);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [isComponentVisible]);

  const handleClose = () => setMenuOpen(false);

  const [width, height] = useWindowSize();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    // Attach the event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={`navbar  ${
        theme == "light" ? "bg-eightColor" : "bg-firstColor"
      } tw-z-[200] tw-relative`}
    >
      <Container fluid="xxl" className="justify-content-center">
        {width < 1000 && (
          <Row className="w-100 align-items-center tw-relative ">
            <Col
              sm="6"
              xs="6"
              className="d-flex align-items-center p-0 color-twelveColor gap-1"
            >
              {/* <BiMenu
                className="menu-icon color-twentyOneColor"
                onClick={toggleMenu}
              /> */}
              <Link
                to={`${window.location.origin}/${
                  MultiLanguageUrl[i18n.language] || "en-US"
                }`}
                className="tw-flex tw-items-center tw-gap-1"
              >
                <LogoIcon theme={theme == "light" ? "blue" : "white"} />
                <span className="font-sofiaSans fw-bold fs-4">LouiseBot</span>
              </Link>
            </Col>

            {/* <Col sm="6" xs="6" className="d-flex justify-content-end p-0">
              {!isAuthentication && (
                <Link
                  hidden={location.pathname.includes("login")}
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }/login`}
                  className="tw-bg-[#19223F] btn  tw-text-indigo-50 tw-rounded-lg"
                >
                  {t("SiteNavbar/l-01")}
                </Link>
              )}

              {isAuthentication && (
                <Link
                  hidden={location.pathname.includes("login")}
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }/login`}
                  className="nav-link nav-btn-light"
                >
                  {t("SiteNavbar/l-02")}
                </Link>
              )}
            </Col> */}
          </Row>
        )}

        {/* header tablet and web size */}
        {width >= 1000 && (
          <Row className="w-100 align-items-center d-lg-flex d-md-flex d-sm-flex">
            <Col
              lg="8"
              md="8"
              sm="8"
              className="d-flex align-items-center gap-4 p-0"
            >
              <Link to="" className="tw-flex tw-items-center tw-gap-2">
                <LogoIcon theme={theme == "light" ? "blue" : "white"} />
                <span className="font-sofiaSans fw-bold fs-4 color-twelveColor">
                  LouiseBot
                </span>
              </Link>

              {/* <Link
                to={`${window.location.origin}/${
                  MultiLanguageUrl[i18n.language] || "en-US"
                }/plans`}
                className={`${
                  theme == "light" ? "color-fifthColor" : "color-sevenColor"
                }`}
              >
                {t("SiteNavbar/l-03")}
              </Link>
              <Link
                to={`${window.location.origin}/${
                  MultiLanguageUrl[i18n.language] || "en-US"
                }/human-clone-page`}
                className={`${
                  theme == "light" ? "color-fifthColor" : "color-sevenColor"
                }`}
              >
                {t("SiteNavbar/l-06")}
              </Link> */}
            </Col>
            {/* <Col
              lg="4"
              md="4"
              sm="4"
              className="d-flex justify-content-end gap-2"
            >
              {!isAuthentication && (
                <>
                  <Link
                    hidden={location.pathname.includes("login")}
                    to={`${window.location.origin}/${
                      MultiLanguageUrl[i18n.language] || "en-US"
                    }/login`}
                    className={`${
                      theme == "light" ? "bg-eightColor" : "bg-firstColor"
                    } nav-link nav-btn-light`}
                  >
                    {t("SiteNavbar/l-01")}
                  </Link>
                  <Link
                    to={`${window.location.origin}/${
                      MultiLanguageUrl[i18n.language] || "en-US"
                    }/plans`}
                    className="nav-btn sofiaSans"
                  >
                    {t("SiteNavbar/l-04")}
                  </Link>
                </>
              )}
              {isAuthentication && (
                <>
                  <Link
                    hidden={location.pathname.includes("login")}
                    to={`${window.location.origin}/${
                      MultiLanguageUrl[i18n.language] || "en-US"
                    }/login`}
                    className="nav-link nav-btn-light"
                  >
                    {t("SiteNavbar/l-02")}
                  </Link>
                </>
              )}
            </Col> */}
          </Row>
        )}
      </Container>

      {menuOpen && (
        <>
          <div
            ref={ref}
            className="tw-absolute tw-top-16 h-100 w-100 tw-h-full   "
          >
            <div className="tw-flex tw-flex-col tw-bg-[#19223F]  w-100 tw-z-[1041] tw-relative">
              <div className="tw-py-3 tw-px-5 tw-border-solid  tw-border-t-0 tw-border-s-0 tw-border-e-0 tw-border-b-[1px] tw-border-[#1D284E]">
                <Link
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }`}
                  className="color-sevenColor font-sofiaSans fs-4"
                  onClick={handleClose}
                >
                  {t("SiteNavbar/l-05")}
                </Link>
              </div>
              <div className="tw-py-3 tw-p-5 tw-border-solid  tw-border-t-0 tw-border-s-0 tw-border-e-0 tw-border-b-[1px] tw-border-[#1D284E]">
                <Link
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }/plans`}
                  className="color-sevenColor font-sofiaSans fs-4"
                  onClick={handleClose}
                >
                  {t("SiteNavbar/l-03")}
                </Link>
              </div>
              <div className="tw-py-3 tw-p-5 tw-border-solid  tw-border-t-0 tw-border-s-0 tw-border-e-0 tw-border-b-[1px] tw-border-[#1D284E]">
                <Link
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }/human-clone-page`}
                  className="color-sevenColor font-sofiaSans fs-4"
                  onClick={handleClose}
                >
                  {t("SiteNavbar/l-06")}
                </Link>
              </div>
              <div className="tw-p-5">
                <Link
                  to={`${window.location.origin}/${
                    MultiLanguageUrl[i18n.language] || "en-US"
                  }/plans`}
                  className="nav-btn w-100 sofiaSans"
                  onClick={() => {
                    setMenuOpen(false);
                  }}
                >
                  {t("SiteNavbar/l-04")}
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
